import React from 'react'
import * as S from './styles'

export const FakeUserInput = () => <S.Input name="user" type="text" readOnly />

export const FakePasswordInput = () => (
  <S.Input name="password" type="password" readOnly />
)
